import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  previewCardContent: {
    padding: theme.spacing(4),
    width: '100% !important',
    boxSizing: 'border-box',
    '& > p:first-child': {
      marginTop: '0 !important',
    },
    '& > h1:first-child': {
      marginTop: '0 !important',
    },
    '& > h2:first-child': {
      marginTop: '0 !important',
    },
    '& > h3:first-child': {
      marginTop: '0 !important',
    },
    '& > h4:first-child': {
      marginTop: '0 !important',
    },
    '& > h5:first-child': {
      marginTop: '0 !important',
    },
    '& > h6:first-child': {
      marginTop: '0 !important',
    },
    '& > p:last-child': {
      marginBottom: '0 !important',
    },
    '& > h1:last-child': {
      marginBottom: '0 !important',
    },
    '& > h2:last-child': {
      marginBottom: '0 !important',
    },
    '& > h3:last-child': {
      marginBottom: '0 !important',
    },
    '& > h4:last-child': {
      marginBottom: '0 !important',
    },
    '& > h5:last-child': {
      marginBottom: '0 !important',
    },
    '& > h6:last-child': {
      marginBottom: '0 !important',
    },
  },
}))
